
/**
 * Searches light DOM (first) and then all shadow roots on page for a given selector,
 * returning 1st element matching the selector
 *
 * @param {string} selector string for document.querySelector() and ...shadowRoot.querySelector()
 * @param {object|undefined} root document or shadow root to search -- else search everything
 * @returns HTMLElement|undefined
 */
const querySelector = (selector, root = document) => {
  const found = root.querySelector(selector);
  if (found) return found;
  for (const el of root.querySelectorAll('*')) {
    if (el.shadowRoot) {
      const result = querySelector(selector, el.shadowRoot);
      if (result) return result;
    }
  }
  return undefined;
};

export default querySelector;
